export default function () {
   return {
      search: JSON.parse(localStorage.getItem('search'))
   }
}